import React, { Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Zoom from 'react-reveal/Zoom';
import { FaTwitter, FaLinkedinIn, FaWhatsapp, FaUsers, FaArrowRight, FaTimes, FaExpand } from 'react-icons/fa';
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import { Link } from 'react-router-dom';
import Wentwrong from '../Wentwrong/Wentwrong';
import ReactPaginate from 'react-paginate';
import '../Team/Team.css';


function TeamSkeleton() {
    return (
        <section style={{ padding: '5rem 0 4rem', background: '#f9fafb' }}>
            <div className="team-container">
                <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
                    <div className="team-skeleton-line" style={{ width: '160px', height: '28px', margin: '0 auto 16px', borderRadius: '999px' }} />
                    <div className="team-skeleton-line" style={{ width: '340px', maxWidth: '90%', height: '44px', margin: '0 auto 12px' }} />
                    <div className="team-skeleton-line" style={{ width: '240px', maxWidth: '90%', height: '44px', margin: '0 auto 20px' }} />
                    <div className="team-skeleton-line" style={{ width: '96px', height: '4px', margin: '0 auto 20px', borderRadius: '999px' }} />
                    <div className="team-skeleton-line" style={{ width: '420px', maxWidth: '90%', height: '15px', margin: '0 auto 8px' }} />
                    <div className="team-skeleton-line" style={{ width: '320px', maxWidth: '90%', height: '15px', margin: '0 auto' }} />
                </div>
                <div className="team-grid">
                    {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
                        <div key={i} className="team-skeleton">
                            <div className="team-skeleton-img" />
                            <div className="team-skeleton-body">
                                <div className="team-skeleton-line" style={{ width: '68%' }} />
                                <div className="team-skeleton-line" style={{ width: '44%', marginTop: '0.5rem' }} />
                                <div className="team-skeleton-socials">
                                    <div className="team-skeleton-dot" />
                                    <div className="team-skeleton-dot" />
                                    <div className="team-skeleton-dot" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

class Allteams extends Component {
    constructor() {
        super();
        this.state = {
            myData: [],
            loaded: false,
            limit: 12,
            paginatedData: [],
            error: false,
            hoveredCard: null,
            selectedMember: null,
            isModalOpen: false,
        };
    }

    componentDidMount() {
        IRestClient.GetRequest(AppUrl.allteams).then(result => {
            if (result == null) {
                this.setState({ error: true, loaded: true });
            } else {
                this.setState({
                    myData: result,
                    paginatedData: result.slice(0, this.state.limit),
                    loaded: true,
                });
            }
        }).catch(() => this.setState({ error: true, loaded: true }));
    }

    componentWillUnmount() {
        document.body.style.overflow = '';
    }

    openModal = (member) => {
        this.setState({ selectedMember: member, isModalOpen: true });
        document.body.style.overflow = 'hidden';
    };

    closeModal = () => {
        this.setState({ selectedMember: null, isModalOpen: false });
        document.body.style.overflow = 'unset';
    };

    handlePageClick = (data) => {
        const offset = data.selected * this.state.limit;
        this.setState({ paginatedData: this.state.myData.slice(offset, offset + this.state.limit) });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    render() {
        if (!this.state.loaded) return <TeamSkeleton />;
        if (this.state.error) return <Wentwrong />;

        const { paginatedData, hoveredCard, isModalOpen, selectedMember } = this.state;

        return (
            <>
                <section style={{ padding: '5rem 0 4rem', background: '#f9fafb' }}>
                    <div className="team-container">

                        {/* Section Header */}
                        <motion.div
                            style={{ textAlign: 'center', marginBottom: '3.5rem' }}
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7 }}
                        >
                            <span style={{
                                display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
                                padding: '0.4rem 1.1rem', background: '#EEF1F9', color: '#1B2B5C',
                                fontSize: '0.78rem', fontWeight: 700, borderRadius: '9999px',
                                border: '1px solid rgba(27,43,92,0.18)', marginBottom: '1.25rem',
                                letterSpacing: '0.08em', textTransform: 'uppercase'
                            }}>
                                <FaUsers style={{ fontSize: '0.75rem' }} />
                                Complete Team
                            </span>

                            <h1 style={{
                                fontSize: 'clamp(2rem, 5vw, 3.25rem)', fontWeight: 900,
                                color: '#111827', lineHeight: 1.12, letterSpacing: '-0.025em',
                                marginBottom: '1.25rem'
                            }}>
                                Meet Our{' '}
                                <span style={{ color: '#1d4ed8' }}>Complete Team</span>
                            </h1>

                            <div style={{
                                width: '5rem', height: '4px',
                                background: 'linear-gradient(to right, #1d4ed8, #60a5fa)',
                                margin: '0 auto 1.5rem', borderRadius: '9999px'
                            }} />

                            <p style={{
                                fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', color: '#6b7280',
                                maxWidth: '40rem', margin: '0 auto', lineHeight: 1.75
                            }}>
                                Discover all the passionate individuals who make our humanitarian mission possible.
                            </p>
                        </motion.div>

                        {/* Team Grid */}
                        <div className="team-grid">
                            {paginatedData.map((team, index) => {
                                const isHovered = hoveredCard === index;
                                const socials = [
                                    team.twitter  && { href: team.twitter,  cls: 'team-social-twitter',  icon: <FaTwitter /> },
                                    team.linkedin && { href: team.linkedin, cls: 'team-social-linkedin', icon: <FaLinkedinIn /> },
                                    team.whatsapp && { href: `https://wa.me/${team.whatsapp.replace(/\D/g, '')}`, cls: 'team-social-whatsapp', icon: <FaWhatsapp /> },
                                ].filter(Boolean);

                                return (
                                    <Zoom key={index} top>
                                        <motion.div
                                            className="team-card"
                                            onMouseEnter={() => this.setState({ hoveredCard: index })}
                                            onMouseLeave={() => this.setState({ hoveredCard: null })}
                                            whileHover={{ y: -6, boxShadow: '0 20px 44px rgba(0,0,0,0.13)', transition: { duration: 0.28 } }}
                                        >
                                            {/* Photo — aspect-ratio 3/4, click opens HD modal */}
                                            <div className="team-photo" onClick={() => this.openModal(team)} style={{ cursor: 'pointer' }}>
                                                <motion.img
                                                    src={team.team_image}
                                                    alt={team.team_name}
                                                    className="team-photo-img"
                                                    animate={{ scale: isHovered ? 1.07 : 1 }}
                                                    transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
                                                    loading="lazy"
                                                />
                                                {/* Hover: dim + centered expand icon only */}
                                                <motion.div
                                                    style={{
                                                        position: 'absolute', inset: 0,
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        background: 'rgba(0,0,0,0.22)',
                                                        pointerEvents: 'none',
                                                    }}
                                                    initial={{ opacity: 0 }}
                                                    animate={{ opacity: isHovered ? 1 : 0 }}
                                                    transition={{ duration: 0.22 }}
                                                >
                                                    <div style={{
                                                        width: '52px', height: '52px',
                                                        background: 'rgba(255,255,255,0.93)',
                                                        borderRadius: '50%',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        boxShadow: '0 4px 20px rgba(0,0,0,0.28)',
                                                    }}>
                                                        <FaExpand style={{ color: '#1d4ed8', fontSize: '17px' }} />
                                                    </div>
                                                </motion.div>
                                            </div>

                                            {/* Info — always visible, no duplication */}
                                            <div className="team-info">
                                                <div className="team-info-accent" />
                                                <h3 className="team-name">{team.team_name}</h3>
                                                <p className="team-role">{team.team_position}</p>
                                                {socials.length > 0 && (
                                                    <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.875rem' }}>
                                                        {socials.map(({ href, cls, icon }, si) => (
                                                            <a key={si} href={href} target="_blank" rel="noopener noreferrer"
                                                                className={`team-social-icon ${cls}`}>
                                                                {icon}
                                                            </a>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </motion.div>
                                    </Zoom>
                                );
                            })}
                        </div>

                        {/* Pagination */}
                        {this.state.myData.length > this.state.limit && (
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '3rem', marginBottom: '1rem' }}>
                                <div style={{ background: 'white', borderRadius: '1rem', padding: '1rem', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
                                    <ReactPaginate
                                        breakLabel="..."
                                        nextLabel="next >"
                                        onPageChange={this.handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={Math.ceil(this.state.myData.length / this.state.limit)}
                                        previousLabel="< previous"
                                        renderOnZeroPageCount={null}
                                        containerClassName="pagination justify-content-center"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        activeClassName="active"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Back to Home */}
                        <div className="team-cta">
                            <motion.div whileHover={{ scale: 1.04, y: -2 }} whileTap={{ scale: 0.97 }} style={{ display: 'inline-block' }}>
                                <Link to="/" className="team-cta-btn">
                                    Back to Home <FaArrowRight />
                                </Link>
                            </motion.div>
                        </div>

                    </div>
                </section>

                {/* Member Modal — click any card to expand */}
                <AnimatePresence>
                    {isModalOpen && selectedMember && (
                        <motion.div
                            className="team-modal-backdrop"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.25 }}
                            onClick={this.closeModal}
                        >
                            <button
                                className="team-modal-close"
                                onClick={e => { e.stopPropagation(); this.closeModal(); }}
                                aria-label="Close"
                            >
                                <FaTimes />
                            </button>

                            <motion.div
                                className="team-modal-card"
                                initial={{ scale: 0.88, opacity: 0, y: 24 }}
                                animate={{ scale: 1, opacity: 1, y: 0 }}
                                exit={{ scale: 0.88, opacity: 0 }}
                                transition={{ duration: 0.32, type: 'spring', stiffness: 320, damping: 28 }}
                                onClick={e => e.stopPropagation()}
                            >
                                <div className="team-modal-photo">
                                    <img src={selectedMember.team_image} alt={selectedMember.team_name} />
                                </div>
                                <div className="team-modal-info">
                                    <div className="team-modal-accent" />
                                    <h3 className="team-modal-name">{selectedMember.team_name}</h3>
                                    <p className="team-modal-role">{selectedMember.team_position}</p>
                                    <div className="team-modal-socials">
                                        {selectedMember.twitter && (
                                            <a href={selectedMember.twitter} target="_blank" rel="noopener noreferrer"
                                                className="team-social-icon team-social-twitter"><FaTwitter /></a>
                                        )}
                                        {selectedMember.linkedin && (
                                            <a href={selectedMember.linkedin} target="_blank" rel="noopener noreferrer"
                                                className="team-social-icon team-social-linkedin"><FaLinkedinIn /></a>
                                        )}
                                        {selectedMember.whatsapp && (
                                            <a href={`https://wa.me/${selectedMember.whatsapp.replace(/\D/g, '')}`}
                                                target="_blank" rel="noopener noreferrer"
                                                className="team-social-icon team-social-whatsapp"><FaWhatsapp /></a>
                                        )}
                                    </div>
                                    <p className="team-modal-hint">Click outside to close</p>
                                </div>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </>
        );
    }
}

export default Allteams;
